class SellingPlansWidget extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.productData = {};
    this.sellingPlanGroups = [];
    this.variants = [];
    this._productRequiresSellingPlan = false;
    this.sellingPlanId = null;
    this.price = null;
    this.compareAtPrice = null;
    this.oneTimePrice = null;
    this.oneTimeCompareAtPrice = null;
    this._currentVariantId = '';
    this.isSubscribeAndSaveVisible = true;
    this.collapse = true;
    this.subscribe= true;
    this.hide_subscribe = false;
    if(document.querySelector('body').classList.contains('new-template-no-subscription')){
      this.isSubscribeAndSaveVisible = false;
      this.collapse = false;
      this.subscribe= false;
      this.hide_subscribe = true;
    }
    
  }

  static get observedAttributes() {
    return ['section-id', 'current-variant-id', 'product-requires-selling-plan'];
  }

  connectedCallback() {
    this.sellingPlanId = this.getAttribute('selling-plan-id');
    this.currentVariantId = this.getAttribute('current-variant-id');
    this.productData = JSON.parse(this.getAttribute('product-data') || '{}');
    this.sellingPlanGroups = this.productData.selling_plan_groups || [];
    this.variants = this.productData.variants || [];
    this.productRequiresSellingPlan = this.productData.requires_selling_plan;
    this.updatePrice();
    this.render();
  }

  handleSubscribeAndSaveClick(e) {}

  handleOneTimePurchaseClick(e) {
    const oneTimePurchaseSlot = this.shadowRoot.querySelector('slot[name="one-time-purchase"]');
    oneTimePurchaseSlot.style.display = 'block';
    const assignedElements = oneTimePurchaseSlot.assignedElements();
    if (assignedElements.length > 0) {
      assignedElements[0].style.display = 'block';
    }

    oneTimePurchaseSlot.style.display = 'block';

    this.sellingPlanId = null;
    this.dispatchEvent(new CustomEvent('selling-plan:change', {
      bubbles: true,
      composed: true,
      detail: {
        sellingPlanId: this.sellingPlanId
      }
    }));
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      switch (name) {
        case 'product-data':
          this.productData = JSON.parse(newValue || '{}');
          break;
        case 'current-variant-id':
          this._currentVariantId = newValue;
          break;
        case 'product-requires-selling-plan':
          this._productRequiresSellingPlan = newValue === 'true';
          break;
        default:
          this[name.replace(/-([a-z])/g, g => g[1].toUpperCase())] = newValue;
      }

      this.updatePrice();
      this.render();
    }
  }

  render() {
    const style = `
  <style>
  .subscribe-and-save-box {
    display: flex;
    justify-content: space-between;
    padding-right: 1em;
    margin-bottom: 5px;
  }

  .delivery-item-box-radio {
    display: flex;
    gap: 8px;
  }

  .price-subscribe {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .subscribe-text {
    color: #000;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    text-transform: capitalize;
  }

  .price-attachemed {
    font-size: 16px;
    margin: 0px;
    color: #000;
    font-family: Nunito Sans !important;
    font-weight: 700;
  }

  .price-original {
    text-decoration: line-through;
    color: #b4b6b8;
  }

  .container-delivery-section ul li label {
    color: #000;
    font-family: Montserrat;
    font-size: 0.825rem !important;
    font-style: normal;
    font-weight: 500;
    line-height: 10px;
    letter-spacing: normal !important;
    display: flex;
    justify-content: space-between;
  }

  .delivery-item label input {
    margin-right: 0;
  }

  .delivery-item {
    margin-bottom: 10px;
    border-radius: 25px;
    border: 1px solid black !important;
    border-radius: 67px;
    border: 1px solid #00a0dd !important;
    background: #16b9ee00;
    box-shadow: 1px 1px 1px rgb(86 182 233);
    margin-bottom: 15px;
  }

  .select-input {
    background-color: rgb(22 185 238 / 85%);
  }

  .select-input .input-title,
  .select-input .annoucenement {
    color: white !important;
    font-weight: 700;
  }

  .input-title {
    line-height: 14px;
  }

  .delivery-item-box-radio-1 {
    color: white;
    font-weight: bold;
  }

  .box-input-text {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    justify-content: space-between;
  }

  .delivery-item label {
    padding: 0.3em 9px;
    margin-bottom: 0;
  }

  .disconut {
    padding-left: 27px;
  }

  .delivery::marker {
    display: none !important;
  }

  .txt-discount {
    margin-bottom: 0;
    font-size: 0.825rem;
    color: #008ecd;
    font-family: Nunito Sans !important;
    font-weight: 800;
    max-width: 80px;
  }

  .select-1 {
    color: white;
    font-weight: bolder;
  }

  .subscribe_and_save-section {
    width: 100%;

  }
  @media (max-width: 1025px) {
    .subscribe_and_save-section:first-child {
          padding-bottom:3em;
    }
  }
  .subscribe_and_save-section-widget {
    transition: max-height 0.3s ease-out;
    max-height: 0;
  }

  .subscribe_and_save-section-widget.active-buttons-subscription,
  .subscribe_and_save-section-widget.active-button-onepurcharse {
    max-height: 100%;
    display: block !important;
  }

  .container-delivery-section ul {
    padding-left: 0;
  }

  ul {
    list-style-type: none;
  }

  .selling_plan_app_container label[for=selling-plan-selector] {
    display: none;
  }

  .off20 {
    color: #000;
    font-family: "Nunito Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .one-time-purchase {
    display: flex;
    color: #000;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    justify-content: space-between;
    align-items: baseline;
    padding-right: 1em;
  }

  .price-one-purchase {
    font-size: 16px;
    color: #000;
    font-family: Nunito Sans !important;
    font-weight: 700;
    margin: 0;
  }

  .box-subscribepurchase {
    display: flex;
    gap: 10px;
    padding-top: 20px;
    padding-bottom: 15px;
    padding-right: 10px;
    justify-content: space-between;
  }

  .input-one-time-purchase {
    color: #000;
    font-family: Montserrat;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 600;
    letter-spacing: normal !important;
    line-height: 20px;
    text-transform: capitalize;
    cursor: pointer;
  }

  .subscribe_and_save-radio {
    display: flex;
    gap: 10px;
    flex-direction: row-reverse;
    justify-content: start;
    align-items: center;
  }

  .subscripcion_disable,
  .subscripcion_disable span {
    color: #000;
    font-family: "Nunito Sans" !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .subscripcion_disable span {
    color: #000;
  }

  .subscribe_and_save-radio input {
    position: relative;
    top: 1px;
  }

  .input-one-time-purchase input {
    position: relative;
    top: 2px;
    display: none;
  }

  .one-time-purchase .ctn-price {
    display: flex;
    gap: 10;
  }

  .subscribe-radio-text {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 52px;
    min-width: 52px;
    height: 25px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 34px;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: #041e42;
  }

  input:checked + .slider:before {
    transform: translateX(26px);
  }

  .custom-select-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
  }

  .purchase-options-select {
    width: 100%;
    height: 50px;
    border-radius: 50px;
    padding: 0 20px;
    border: 1px solid rgba(4, 30, 66, 0.20);    
    appearance: none;
    background-color: #fff;
    cursor: pointer;
    margin-top: 10px;
    margin-bottom: 20px;    
    font-family: Montserrat;    
    -moz-appearance: none; 
    -webkit-appearance: none; 
    appearance: none;
    font-size:16px;    
  }

  .custom-arrow {
    position: absolute;
    top: 45%;
    right: 10px;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #2b2967;
    transform: translateY(-50%);
    pointer-events: none;
    z-index: 1;
  }

  .pop-up {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .popup_text {
    color: #000;
    font-family: Montserrat;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 600;
    letter-spacing: normal !important;
    line-height: 20px;
    text-transform: capitalize;
    cursor: pointer;
  }
  .title-select{
    color: #000;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    display: block;
  }

  @media (max-width: 1290px) {
    .container-delivery-section ul li label {
      font-size: 0.725rem !important;
    }

    .txt-discount {
      font-size: 0.725rem;
    }
  }

  @media (max-width: 1167px) {
    .txt-discount {
      font-size: 0.625rem;
    }

    .container-delivery-section ul li label {
      font-size: 0.625rem !important;
    }
    .pop-up{
      padding-top:10px;
    }
  }

  @media (max-width: 1050px) {
    .subscribe_and_save-box,
    .one-time-purchase,
    .box-subscribepurchase {
      flex-wrap:wrap;
      padding-right: 0;
    }

    .txt-discount {
      font-size: 0.625rem;
    }
  }

  @media (max-width: 1030px) {
    .txt-discount {
      font-size: 0.625rem;
    }

    .container-delivery-section ul li label {
      font-size: 0.625rem !important;
    }
  }

  @media (max-width: 850px) {
    .container-delivery-section ul li label {
      font-size: 0.525rem !important;
    }
    .txt-discount {
      font-size: 0.525rem;
      }    
  }
    @media (max-width: 500px) {
      .purchase-options-select {
      padding: 10px 27px 10px 10px;
      }
    }
  
</style>
    `;
    const content = `
      <div id="return-div"  class="selling_plan_app_container" data-section-id="selling-plan-section">
        <section data-variant-id="${this.currentVariantId || ''}" class='selling_plan_theme_integration'>
        <div class="box-subscribepurchase" ${this.hide_subscribe ? 'style="display:none;"' : ''}>
          <span class="subscribe_and_save-radio">
            <span class="subscripcion_disable" >Subscription: ${this.subscribe ? '<span style="color:#041e42;" >Active</span>' : '<span style="color:#ccc;">Disabled</span>'}</span>
              <label class="switch">
                <input id="subscribe-collap" type="checkbox" ${this.collapse ? 'checked' : ''}>
                <span  class="slider"></span>
              </label>
              </span>
              <div class="pop-up">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.5 13.75C10.95 13.75 13.75 10.95 13.75 7.5C13.75 4.05 10.95 1.25 7.5 1.25C4.05 1.25 1.25 4.05 1.25 7.5C1.25 10.95 4.05 13.75 7.5 13.75ZM6.875 4.375L8.125 4.375L8.125 5.625L6.875 5.625L6.875 4.375ZM6.875 6.875L8.125 6.875L8.125 10.625L6.875 10.625L6.875 6.875Z" fill="black"/>
              </svg>
              <div class="popup_text">How does subscription work?</div>
            </div> 
        </div>
        <div class="subscribe_and_save-section ${this.subscribe === true ? 'subscribe_box' : ''}">
        ${this.subscribe === true ? this.renderSubscribePurchase() : ''}
        </div>
          <div class="box-subscribepurchase" ${this.hide_subscribe ? 'style="display:none;"' : ''}>
          <span class="subscribe_and_save-radio">
            <span class="subscripcion_disable" >One-time purchase: ${!this.subscribe ? '<span style="color:#041e42;" >Active</span>' : '<span style="color:#ccc;">Disabled</span>'}</span>
            <label class="switch">
              <input id="oneTime-collap" type="checkbox" ${!this.collapse ? 'checked' : ''}>
              <span  class="slider"></span>
            </label>
          </span>
        </div>
        <div class="subscribe_and_save-section">
          ${!this.subscribe === true ? this.renderOneTimePurchase() : ''}
        </div>
        </section>
        <slot></slot>
      </div>
    `;

    this.shadowRoot.innerHTML = style + content;

    const subscribeAndSave = this.shadowRoot.querySelector('#subscribe-collap');
    const oneTimePurchase = this.shadowRoot.querySelector('#oneTime-collap');
    subscribeAndSave.addEventListener('click', this.handleCollapClick.bind(this));
    oneTimePurchase.addEventListener('click', this.handleCollapClick.bind(this));
    
    this.modalLink = this.shadowRoot.querySelector('.pop-up .popup_text');
    this.modalLink.addEventListener('click', () => {
      this.dispatchEvent(new CustomEvent('modal:open', {
        bubbles: true,
        composed: true,
        detail: {
          modalId: this.sectionId
        }
      }));
    });

    this.listenToVariantChange();
    this.listenToSellingPlanFormSelectChange();
    this.shadowRoot.querySelector('#oneTime-collap').addEventListener('click', () => {
    const targetElement = this.shadowRoot.querySelector('#return-div');
    if (this.shadowRoot.querySelector('#oneTime-collap').checked) {
        
        targetElement.scrollIntoView({
            behavior: 'smooth',  
            block: 'start'      
        });
    }
});
  }

  handleCollapClick() {
    this.collapse = !this.collapse;
    this.subscribe = !this.subscribe;
    if(this.subscribe !== true){
      this.render()
      this.handleOneTimePurchaseClick();
    } else {
      this.sellingPlanId = this.getAttribute('selling-plan-id');
      this.dispatchEvent(new CustomEvent('selling-plan:change', {
        bubbles: true,
        composed: true,
        detail: {
          sellingPlanId: this.sellingPlanId
        }
      }));
      this.updatePrice();
      this.render();
    }
  };

  renderSellingPlanSelector() {
    const sellingPlanGroups = this.sellingPlanGroups || [];
    return sellingPlanGroups.map(group => this.renderSellingPlanGroup(group)).join('');
  }

  renderSellingPlanGroup(group) {
    const variantAllocations = this.getVariantData(this.currentVariantId).sellingPlanAllocations || [];
    const sellingPlanAllocations = variantAllocations.filter(allocation => allocation.sellingPlanGroupId === group.id);
    sellingPlanAllocations.forEach(plan => {
      plan.sellingPlanName = plan.sellingPlanName.replace("Get 20% off today and all future orders.", "").trim();
    });
    return ` 

    <div class="custom-select-wrapper">
        <select class="purchase-options-select">
            ${sellingPlanAllocations.map(sellingPlanAllocation => this.renderSellingPlan(sellingPlanAllocation)).join('')}
        </select>
        <div class="custom-arrow"></div>
    </div>
      `;
  }

  renderOneTimePurchase() {
    if (this.productRequiresSellingPlan) return '';
    return `
        <div class="subscribe_and_save-container">
              <div class="one-time-purchase">
                <label class="input-one-time-purchase">
                  <input
                    class="subscribe_and_save-radio"
                    id="subscribe_and_save-radio-onepurchase"
                    aria-label='One-time purchase. Product price ${this.oneTimePrice}'
                    type='radio'
                    name="purchaseOption_${this.sectionId}_${this.variantId}"
                    ${!this.sellingPlanId ? 'checked' : ''}
                    id='${this.sectionId}_one_time_purchase'
                    data-radio-type='one_time_purchase'
                    data-variant-id='${this.variantId}'
                    data-variant-price='${this.oneTimePrice}'
                    data-variant-compare-at-price='${this.oneTimeCompareAtPrice}'
                  />
                  One-time purchase
                </label>
                <div class="ctn-price">
                  <p class="sub-text-pdp"></p>
                  <p class="price-one-purchase" >${this.oneTimePrice}</p>
                </div>
              </div>
              <slot name="one-time-purchase" ${ this.subscribe == true ? 'style="display: none;"' : '' }></slot>
              <div id="one-purchase" class="subscribe_and_save-section-widget active-button-onepurcharse">
                <slot name="buy-buttons" ${ this.subscribe == true ? 'style="display: none;"' : '' }></slot>
              </div>
            </div>`;

  }
  

  getTwentyPercentDiscountPrice(price) {
	  if (!price) return '';

	  const numericPrice = Number(
	    price
	      .replace(/[^0-9.,]/g, '')
	      .replace(',', '.')
	  );

	  if (Number.isNaN(numericPrice)) return price;

	  const discountedPrice = numericPrice * 0.8;

	  return new Intl.NumberFormat('en-US', {
	    style: 'currency',
	    currency: 'USD'
	  }).format(discountedPrice);
	}

	renderSubscribePurchase() {
	  const compareAtPrice = this.compareAtPrice || this.price;
	  const subscriptionPrice = this.getTwentyPercentDiscountPrice(compareAtPrice);

	  return `
	    <div class="subscribe_and_save-container ">
	      <div class="subscribe_and_save" ${this.hide_subscribe ? 'style="display:none;"' : ''}>
	        <div class="input-one-time-purchase subscribe-and-save-box active">
	          <div class="subscribe-radio-text">
	            <span class="subscribe-text">Subscribe and save </span>
	          </div>

	          <div class="price-subscribe">
	            <p class="price-attachemed price-original">${compareAtPrice}</p>
	            <p class="price-attachemed">${subscriptionPrice}</p>
	          </div>
	        </div>

	        <span class="off20"> 
	          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
	            <path d="M11.6937 10.4406L13.125 11.8719L13.125 6.87188L8.125 6.87188L9.5625 8.30938C8.65 9.54063 7.2 10.3406 5.55 10.3406C4.73125 10.3406 3.9625 10.1406 3.28125 9.79063C4.23125 11.2469 5.86875 12.2156 7.7375 12.2156C9.3125 12.2156 10.7187 11.5219 11.6937 10.4406Z" fill="black"/>
	            <path d="M9.45 4.65938C10.2688 4.65938 11.0375 4.85938 11.7188 5.20938C10.7688 3.74688 9.13125 2.78438 7.2625 2.78438C5.6875 2.78438 4.28125 3.47188 3.30625 4.55938L1.875 3.12188L1.875 8.12188L6.875 8.12188L5.4375 6.68438C6.35 5.45938 7.8 4.65938 9.45 4.65938Z" fill="black"/>
	          </svg> 
	          Save 20% when you subscribe
	        </span>

	        <div class="ctn-price">
	          <p class="sub-text-pdp"></p>
	          <p class="plan-price price" allocation-price-render>${subscriptionPrice}</p>
	        </div>
	      </div>

	      <div id="subscribeWidget" class="subscribe_and_save-section-widget ${this.isSubscribeAndSaveVisible ? 'active-buttons-subscription' : ''}" style="display: none;">
	        <div class="container-delivery-section iten-collapse">
	          <span class="title-select">Select a plan</span>
	          <slot name="subscribe-and-save-top"></slot>
	          ${this.renderSellingPlanSelector()}
	          <slot name="subscribe-and-save-bottom"></slot>
	          <slot name="buy-buttons"></slot>
	        </div>
	      </div>
	    </div>`;
	}

	renderSellingPlan(allocation) {
	  const sellingPlanId = String(allocation.sellingPlanId);
	  const currentSellingPlanId = String(this.sellingPlanId || '');
	  const compareAtPrice = allocation.compareAtPrice || allocation.price;
	  const subscriptionPrice = this.getTwentyPercentDiscountPrice(compareAtPrice);

	  return `
	    <option 
	      value="${sellingPlanId}"
	      ${sellingPlanId === currentSellingPlanId ? 'selected' : ''}
	      data-selling-plan-id="${sellingPlanId}"
	      data-selling-plan-group-id="${allocation.sellingPlanGroupId}"
	      data-variant-price="${subscriptionPrice}"
	      data-variant-compare-at-price="${compareAtPrice}"
	    >
	      ${allocation.sellingPlanName} - ${subscriptionPrice}
	    </option>
	  `;
	}

	handleSellingPlanChange(sellingPlanId) {
	  this.sellingPlanId = String(sellingPlanId);

	  this.dispatchEvent(new CustomEvent('selling-plan:change', {
	    bubbles: true,
	    composed: true,
	    detail: {
	      sellingPlanId: this.sellingPlanId
	    }
	  }));

	  this.updatePrice();
	  this.render();
	}

  listenToVariantChange() {
    document.addEventListener('variant:change', this.handleVariantChange.bind(this));
  }

  listenToSellingPlanFormSelectChange() {
    const sellingPlansSelector = this.shadowRoot.querySelector('select.purchase-options-select');
    sellingPlansSelector?.addEventListener('change', event => {
      const sellingPlanId = sellingPlansSelector.options[sellingPlansSelector.selectedIndex].value;
      this.handleSellingPlanChange(sellingPlanId)
    })
  }

 handleVariantChange(evt) {
  this.variantId = evt.detail.variant.id;
  this.updatePrice();
  this.setAttribute('current-variant-id', this.variantId);
  
  // Dispatch a more detailed variant change event for price updates
  this.dispatchEvent(new CustomEvent('variant:change', {
    bubbles: true,
    composed: true,
    detail: {
      variant: {
        id: this.variantId,
        // Add any other variant properties needed
      }
    }
  }));
}

	updatePrice() {
	  const variantData = this.getVariantData(this.currentVariantId);

	  if (variantData) {
	    if (this.sellingPlanId) {
	      const allocation = variantData.sellingPlanAllocations.find(
	        a => String(a.sellingPlanId) === String(this.sellingPlanId)
	      );

	      if (allocation) {
	        this.price = allocation.price;
	        this.compareAtPrice = allocation.compareAtPrice;
	      }
	    } else {
	      this.price = variantData.price;
	      this.compareAtPrice = variantData.compareAtPrice;
	    }

	    this.oneTimePrice = variantData.price;
	    this.oneTimeCompareAtPrice = variantData.compareAtPrice;
	  }
	}

  getVariantData(variantId) {
    const scriptElement = this.querySelector(`script[data-variant-id="${variantId}"]`);
    return scriptElement ? JSON.parse(scriptElement.textContent || '{}') : null;
  }

  get currentVariantId() {
    return this._currentVariantId;
  }

  set currentVariantId(value) {
    this._currentVariantId = value;
  }

  get productRequiresSellingPlan() {
    return this._productRequiresSellingPlan;
  }

  set productRequiresSellingPlan(value) {
    this._productRequiresSellingPlan = value;
  }

  disconnectedCallback() {}
}

customElements.define('selling-plans-widget', SellingPlansWidget);


document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('selling-plan:change', (event) => {
    const sellingPlanId = event.detail.sellingPlanId;
    const form = document.querySelector(`form[id^="AddToCartForm"]`);

    if (form) {
      const sellingPlanInput = form.querySelector(`input[name="selling_plan"]`);
      if (sellingPlanInput) {

        sellingPlanInput.value = sellingPlanId;
      } else {
        const sellingPlanInput = document.createElement('input');
        sellingPlanInput.type = 'hidden';
        sellingPlanInput.name = 'selling_plan';
        sellingPlanInput.value = sellingPlanId;
        form.appendChild(sellingPlanInput);
      }
    }
  });

  document.querySelector('selling-plans-widget').querySelectorAll('.add-to-cart').forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      const form = document.querySelector('.product-single__form');
      if (form) {
        const submitEvent = new Event('submit', {bubbles: true,cancelable: true,});
        form.dispatchEvent(submitEvent);
      }
    });

  });

  document.addEventListener('variant:change', event => {
    if (event.detail.index === "option1") {
      document.querySelectorAll('.button-dog').forEach(button => {
        if (button.dataset.value === event.detail.value) {
          button.classList.add('button-selected');
        } else {
          button.classList.remove('button-selected');
        }
      });
    }
  });
});